import https from "./url.js"

// 获取分类信息
export const Detailsdata = function(ids){
    // console.log(https.get('/one'))
    return https.get('/api/portal/index/Details?id='+ids)
}

// 产品列表
export const Listdata = function(ids){
    // console.log(https.get('/one'))
    return https.get('/api/portal/index/Productlist?category='+ids)
}




// WEBPACK FOOTER //
// ./src/api/Product.js